import { render, staticRenderFns } from "./DecisoriosLista.vue?vue&type=template&id=54af5b4e&scoped=true&"
import script from "./DecisoriosLista.vue?vue&type=script&lang=js&"
export * from "./DecisoriosLista.vue?vue&type=script&lang=js&"
import style0 from "./DecisoriosLista.vue?vue&type=style&index=0&id=54af5b4e&scoped=true&lang=css&"
import style1 from "./DecisoriosLista.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54af5b4e",
  null
  
)

export default component.exports